import React, { createContext, useContext, useState } from "react";
import LogoutTipModal from "components/LogoutModals/LogoutTipModals";
import { useAuth } from "./AuthProvider";
import { useData } from "./DataProvider";
import { useNetworkStatus } from "hooks/useNetworkStatus";

interface LogoutModalContextType {
	openLogoutModal: () => void;
	closeLogoutModal: () => void;
}

const LogoutModalContext = createContext<LogoutModalContextType | null>(null);

export const LogoutModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const auth = useAuth();
	const data = useData();
	const { isOnline } = useNetworkStatus();
	const [open, setOpen] = useState(false);

	const openLogoutModal = () => {
		setOpen(true);
	};

	const closeLogoutModal = () => {
		setOpen(false);
	};

	const handleLogout = () => {
		auth.logout();
		data.clearAllData();
		setOpen(false);
	};

	return (
		<LogoutModalContext.Provider value={{ openLogoutModal, closeLogoutModal }}>
			{children}
			<LogoutTipModal
				open={open}
				isOnline={isOnline}
				onClose={closeLogoutModal}
				handleLogout={handleLogout}
			/>
		</LogoutModalContext.Provider>
	);
};

export const useLogoutModal = () => {
	const context = useContext(LogoutModalContext);
	if (!context) {
		throw new Error("useLogoutModal must be used within LogoutModalProvider");
	}
	return context;
};
